export const LANDING = '/';
export const SIGN_IN = '/sign-in';
export const SIGN_UP = '/sign-up';
export const USER_PAGE = '/user-page';
export const FILM_PAGE = '/film';
export const FAVORITES_PAGE = '/favorites';
